import { Col, Divider, Row } from "antd";
import React from "react";
import { CustomInput } from "../../Components/CustomInput/Input";
import { CustomLabel } from "../../Constant";

const InputFormComponent = ({ label, msg, error = false, ...props }) => {
  return (
    <div className={"cls_mghunt8j_397fc0"}>
      <Row justify="space-between">
        <Col span={10}>
          <CustomLabel>
            {label} <span className={"cls_mghunt8k_02f323"}>*</span>
          </CustomLabel>
        </Col>
        <Col lg={10} md={12} xs={12}>
          <CustomInput error={error} {...props} />
          {error && (
            <div className={"cls_mghunt8k_5e2ded"}>
              {" "}
              <label className={"cls_mghunt8k_56de7a"}>{msg}</label>
            </div>
          )}
        </Col>
        <Divider />
      </Row>
    </div>
  );
};

export default InputFormComponent;
